import { createImpressionEvent } from '../base';
import { PORTFOLIO_EVENT_PARAMS } from '../constants';

/**
 * BI impression event for the Portfolio Presence component.
 * @param {string} type The event's type.
 * @returns {object} parameters for the event.
 */
export const createPortfolioImpressionEvent = (type) => createImpressionEvent(type, PORTFOLIO_EVENT_PARAMS);
